<template>
    <section class="container">
        <div>
            <div class="area_title">
                <p>홍보물품대장</p>
                <div class="area_button">
                    <button type="button" @click="showModal">
                        <span>수정</span>
                    </button>

                    <button type="button" @click="confirmRemove">
                        <span>삭제</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <img :src="state.data.file" style="width: 300px; height: auto" />
                </div>

                <div class="area_section">
                    <ul class="area_ul">
                        <li>
                            <label>물품명</label>
                            <p v-text="state.data.name"></p>
                        </li>
                        <li>
                            <label>등록자</label>
                            <p v-text="state.data.writer"></p>
                        </li>
                        <li>
                            <label>부서</label>
                            <p v-text="state.data.team"></p>
                        </li>
                        <li>
                            <label>잔고량</label>
                            <p>{{ state.data.cnt ? CommonUtils.numberFormat(state.data.cnt) : "0" }}</p>
                        </li>
                        <li>
                            <label>등록일자</label>
                            <p v-text="CommonUtils.dateFormat(state.data.createDate, '.', true)"></p>
                        </li>
                        <li>
                            <label>최근 입고일</label>
                            <p v-text="CommonUtils.dateFormat(state.data.recentEntireDate, '.', true)"></p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <ItemAdd v-if="state.isShowAddModal" :data="state.data" @callback="itemUpdate" @close="state.isShowAddModal = false"></ItemAdd>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        reactive,
        apiService,
        onMounted,
        router,
        ModalDefault,
        types,
        getMessageByCode,
        CommonUtils,
        CommonOptions,
        ItemAdd,
        watch,
        useRoute,
    } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
            refreshFlag: {
                type: Boolean,
                default: false,
            },
        },
        components: { ModalDefault, ItemAdd },
        emits: ["callback"],
        setup(props: any, { emit }: any) {
            const route = useRoute();
            const state = reactive({
                isShowAddModal: false as boolean,
                idx: 0 as number,
                data: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            onMounted(() => {
                state.idx = Number(route.params.id);
                fnGetDetail();
            });

            watch(props, () => {
                if (props.refreshFlag === true) {
                    fnGetDetail();
                }
            });

            const fnGetDetail = async () => {
                const res = await apiService.item.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                    emit("callback");
                }
            };

            const showModal = () => {
                state.isShowAddModal = true;
            };

            const closeModal = () => {
                if (state.modalTab === 3) {
                    router.back();
                } else {
                    state.isShowModal = false;
                }
            };

            const confirmRemove = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
            };

            const itemUpdate = async (param: any) => {
                const param_for_modify: types.item.ReqItemForModify = {
                    idx: param.idx,
                    name: param.name,
                    isShare: param.isShare ? 1 : 0,
                    file: param.file,
                    team: param.dept,
                };
                const res = await apiService.item.modify(param_for_modify);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "저장이 완료되었습니다.";
                    state.isShowModal = true;
                    state.isShowAddModal = false;
                    fnGetDetail();
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    removeItem();
                } else if (param.action === "callback") {
                    router.back();
                }
            };

            const removeItem = async () => {
                const res = await apiService.item.remove(state.idx);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "안내";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,
                CommonUtils,
                CommonOptions,
                showModal,
                closeModal,
                callbackModal,
                removeItem,
                confirmRemove,
                itemUpdate,
            };
        },
    };
</script>
<style scoped>
    .container {
        min-width: auto;
        width: auto;
    }

    .container:first-of-type div.area_title > div.area_button {
        right: 0px;
    }

    ul.area_ul > li {
        display: flex;
        border: 1px solid #d9d9d9;
    }

    ul.area_ul > li + li {
        border-top: 0px;
    }

    ul.area_ul > li > label {
        width: 100px;
        padding: 8px 0px 8px 10px;
        border-right: 1px solid #d9d9d9;
    }

    ul.area_ul > li > p {
        width: 200px;
        padding: 8px 0px 8px 10px;
    }
</style>
